import { render, staticRenderFns } from "./comprehensiveValuation.vue?vue&type=template&id=68e906cc&scoped=true&"
import script from "./comprehensiveValuation.vue?vue&type=script&lang=js&"
export * from "./comprehensiveValuation.vue?vue&type=script&lang=js&"
import style0 from "./comprehensiveValuation.vue?vue&type=style&index=0&id=68e906cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e906cc",
  null
  
)

export default component.exports